import React from 'react';

class KskdbTableCount extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;
    let kskdb = hostInfo.kioskInfo.kskdb || {};

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>kskdb.table count</div>
        </div>

        <div className='info-card pure-u-3-24'>
          <span>TransQue:</span>
          <div style={{ color: kskdb.transqueCount > 0 ? 'red' : 'green' }}>
            {kskdb.transqueCount}
          </div>
        </div>
        <div className='info-card pure-u-3-24'>
          <span>CCLocal:</span>
          <div style={{ color: kskdb.cclocalCount > 0 ? 'red' : 'green' }}>
            {kskdb.cclocalCount}
          </div>
        </div>
        <div className='info-card pure-u-3-24'>
          <span>CCQuarantine:</span>
          <div style={{ color: kskdb.ccquarantineCount > 0 ? 'red' : 'green' }}>
            {kskdb.ccquarantineCount}
          </div>
        </div>
        <div className='info-card pure-u-3-24'>
          <span>CCUpdate:</span>
          <div style={{ color: kskdb.ccupdateCount > 0 ? 'red' : 'green' }}>
            {kskdb.ccupdateCount}
          </div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>CCHistory:</span>
          {kskdb.cchistoryCount}
        </div>
        <div className='info-card pure-u-4-24'>
          <span>TransID SeqNbr:</span>
          {kskdb.transidSeqnbr}
        </div>
        <div className='info-card pure-u-4-24'>
          <span>CreditCard SeqNbr:</span>
          {kskdb.ccSeqnbr}
        </div>

        <div className='info-card pure-u-3-24'>
          <span>SalesHeader:</span>
          {kskdb.sahCount}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>SalesPayment:</span>
          {kskdb.sapCount}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>SalesItem:</span>
          {kskdb.saiCount}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>SalesItemModifier:</span>
          {kskdb.saimCount}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>PricingRec:</span>
          {kskdb.pricingrecCount}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Cmr:</span>
          {kskdb.cmrlistCount}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Staff:</span>
          {kskdb.staffCount}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Card:</span>
          {kskdb.cardCount}
        </div>
      </div>
    );
  }
}

export default KskdbTableCount;



// WEBPACK FOOTER //
// ./src/components/KskdbTableCount.js